import { ChevronDown, ChevronUp, ChevronsUpDown } from "lucide-react";

export function SortIcon<K extends string>({ col, sortKey, sortDir }: { col: K; sortKey: K; sortDir: "asc" | "desc" }) {
  if (col !== sortKey) return <ChevronsUpDown className="ml-1 inline h-3 w-3 opacity-40" />;
  return sortDir === "asc" ? (
    <ChevronUp className="ml-1 inline h-3 w-3" />
  ) : (
    <ChevronDown className="ml-1 inline h-3 w-3" />
  );
}

export function ariaSortValue<K extends string>(
  col: K,
  sortKey: K,
  sortDir: "asc" | "desc",
): "ascending" | "descending" | "none" {
  if (col !== sortKey) return "none";
  return sortDir === "asc" ? "ascending" : "descending";
}
